var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, updateData, createData } from "../dataAccess";
//============================================================================================================
//                                              SPECIES
//============================================================================================================
export const getSpecies = (includeArchived) => __awaiter(void 0, void 0, void 0, function* () {
    let url = `Species/species`;
    if (includeArchived) {
        url = url + `?includeArchived=true`;
    }
    return getData(url);
});
// Update an existing site
export const updateSpecies = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Species/species-update`;
    return updateData(url, item);
});
// Create a new site
export const createSpecies = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Species/species-create`;
    return createData(url, item);
});
export const deleteSpecies = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Species/species-delete`;
    return updateData(url, [item]);
});
